import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BusinessMpProvider from "@/core/data-provider/data-mp/business/business-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setPurchaseHistoryData } from "@/domains/business/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetHistory(businessId: number, currentPage: number, pageSize: number) {
  const { t, i18n } = useTranslation("business");
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (businessId && currentPage && pageSize) {
      setIsLoading(true);

      try {
        const response = await BusinessMpProvider.getHistory(businessId, currentPage, pageSize);

        if (response instanceof RpcMpProviderSuccessResponse) {
          dispatch(setPurchaseHistoryData(response.data));
        } else if (i18n.exists(`business:business.errors.${response.error.message}`)) {
          console.error(response.error.message);
          toast.error(t(`business.errors.${response.error.message}`));
        } else {
          console.error(response.error.message);
          toast.error(t("business.toast.historyLoadError"));
        }
      } catch (e) {
        console.error(e);
        toast.error(t("business.toast.historyLoadError"));
      } finally {
        setIsLoading(false);
      }
    }
  }, [businessId, currentPage, dispatch, i18n, pageSize, t]);

  useEffect(() => {
    load();
  }, [load]);

  return { isLoading };
}
